import React, { memo } from 'react'
import CommonDialog from '../../../common/components/dialog/CommonDialog'
import styles from './ArhiveProductDialog.module.scss'
import { SolarProduct } from '../../../model/solar-product/solar-product'
import solarProductService from '../../../httpService/SolarProductService'
import { useDispatch } from 'react-redux'
import { hideLoader, showLoader } from '../../../stores/slices/loader-slice'
import { toast } from 'react-toastify'

type Props = {
    product: SolarProduct
    onCloseDialog: () => void
    onProductArchived: () => void
}

const ArhiveProductDialog: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch();

    const arhiveProduct = () => {
        dispatch(showLoader());
        solarProductService.archive(props.product.id!).then(() => {
            props.onProductArchived();
        }).catch(() => {
            toast.error('Failed to arhive product');
        }).finally(() => {
            dispatch(hideLoader());
            props.onCloseDialog();
        });
    }

    const cancel = () => {
        props.onCloseDialog();
    }

    return (
        <CommonDialog onCloseDialog={props.onCloseDialog}>
            <div className={styles.container}>
                <div className={styles.title}>
                    Are you sure you want to {
                        props.product.isArchived ? 'unarchive' : 'archive'
                    } this product?
                </div>
                <div className={styles.description}>
                    {
                        props.product.isArchived ? 'Unarchiving' : 'Archiving'
                    } a product will make it {
                        props.product.isArchived ? 'available' : 'unavailable'
                    } for purchase by customers.
                </div>

                <div className={styles.buttonContainer}>
                    <button className={`standardButton ${styles.button} ${styles.archiveButton}`} onClick={arhiveProduct}>{
                        props.product.isArchived ? 'Unarchive' : 'Archive'
                    }</button>
                    <button className={`standardButton ${styles.button}`} onClick={cancel}>Cancel</button>
                </div>
            </div>
        </CommonDialog>
    )
})

export default ArhiveProductDialog